import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);
root.render(<React.StrictMode data-id="element-284">
    <App data-id="element-285" />
  </React.StrictMode>);